import React from 'react';

const IconLogo = () => (
  <svg
    id="logo"
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="180.000000pt"
    height="180.000000pt"
    viewBox="0 0 180.000000 180.000000"
    preserveAspectRatio="xMidYMid meet">
    <metadata>Pradip Dhakal logo</metadata>
    <g
      transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)"
      fill="#0a192f"
      stroke="none">
      <path
        d="M670 1779 c-314 -81 -569 -339 -651 -656 -27 -108 -27 -338 0 -446
82 -319 339 -577 655 -657 112 -28 340 -28 452 0 316 80 573 338 655 657 27
108 27 338 0 446 -82 319 -339 577 -655 657 -110 28 -347 28 -456 -1z m381
-303 c206 -44 325 -193 304 -382 -13 -123 -108 -260 -215 -312 -93 -44 -265
-47 -311 -6 -32 29 -20 58 26 68 158 34 211 69 241 159 23 69 23 182 1 224
-36 68 -85 98 -185 113 -99 16 -212 -5 -327 -59 -122 -57 -158 -55 -128 7 34
71 169 157 291 187 75 18 220 18 303 1z m-257 -312 c-1 -71 -11 -150 -37 -279
-27 -133 -39 -224 -46 -348 -9 -180 -13 -190 -68 -214 -45 -18 -137 -17 -153
2 -18 22 -16 209 3 320 34 192 115 431 179 530 33 50 93 99 112 92 7 -3 11
-41 10 -103z"
        fill="#64ffda"
      />
    </g>
  </svg>
);

export default IconLogo;
